
    var riot = require('riot')
    //src: starling/src/tags/modal-share/panel-link.html
riot.tag2('panel-link',
  '<div if="{this.workspaceDisablesLinkSharing()}" class="link-panel link-panel--disabled"> <div class="link-panel_body"> <span class="link-panel_message_text">This workspace has disabled link sharing with non-members</span> </div> </div> <div class="link-panel {!viewLinkAvailable() && \'link-panel--disabled\'} {workspaceDisablesLinkSharing() && \'link-panel--locked\'}"> <div class="link-panel_body"> <span class="link-panel_icon_container"> <svg class="link-panel_icon"> <use xlink:href="#visibility-icon"></use> </svg> </span> <div class="link-panel_content"> <h3 class="link-panel_title">View-only link</h3> <p if="{!isInWorkspace()}" class="link-panel_description">Anyone with this link can view this map</p> <p if="{isInWorkspace()}" class="link-panel_description">Non-members of <b>{window.workspace.name}</b> with this link can view this map</p> </div> <div class="link-panel_menu"> <button if="{canModify()}" class="link-panel_menu_button" onclick="{toggleViewMenu}"> {viewLinkAvailable() ? \'On\' : \'Off\'} <svg class="link-panel_menu_icon"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> <div ref="viewMenu" class="floating-menu floating-menu--bottom floating-menu--right floating-menu--small floating-menu--hidden"> <ul class="floating-menu_list"> <li class="floating-menu_item {!viewLinkAvailable() && \'floating-menu_item--iconless\'}" onclick="{toggleViewLink.bind(this, true)}"> <svg if="{viewLinkAvailable()}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">On</span> </li> <li class="floating-menu_item {viewLinkAvailable() && \'floating-menu_item--iconless\'}" onclick="{toggleViewLink.bind(this, false)}"> <svg if="{!viewLinkAvailable()}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Off</span> </li> </ul> </div> </div> </div> <div if="{!canvas.isViewOnly() && canModify() && canvas.isFeatureEnabled(\'comments\')}" class="link-panel_switch"> <label class="link-panel_label" for="view-links-can-comment_checkbox"> <svg class="link-panel_label_icon"> <use xlink:href="#comment-text-outline-icon"></use> </svg> Anyone with a link can comment </label> <switch name="view-links-can-comment" checked="{viewLinksCanComment()}" disabled="{!viewLinkAvailable()}" toggle="{toggleViewLinkCommenting}"></switch> </div> <div class="link-panel_url"> <input class="link-panel_input" type="text" riot-value="{viewUrl()}" readonly disabled="{!viewLinkAvailable()}" ondblclick="{selectAll}" onclick="{selectAll}"> <button class="Button Button--Small" onclick="{copyLink}">Copy</button> </div> </div> <div if="{!canvas.isViewOnly()}" class="link-panel {!editLinkAvailable() && \'link-panel--disabled\'} {workspaceDisablesLinkSharing() && \'link-panel--locked\'}"> <div class="link-panel_body"> <span class="link-panel_icon_container"> <svg class="link-panel_icon"> <use xlink:href="#edit-icon"></use> </svg> </span> <div class="link-panel_content"> <h3 class="link-panel_title">Edit link</h3> <p if="{!isInWorkspace()}" class="link-panel_description">Anyone with this link can edit this map and invite others to edit</p> <p if="{isInWorkspace()}" class="link-panel_description">Non-members of <b>{window.workspace.name}</b> with this link can edit this map and invite others to edit</p> </div> <div class="link-panel_menu"> <button if="{canModify()}" class="link-panel_menu_button" onclick="{toggleEditMenu}"> {editLinkAvailable() ? \'On\' : \'Off\'} <svg class="link-panel_menu_icon"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> <div ref="editMenu" class="floating-menu floating-menu--bottom floating-menu--right floating-menu--small floating-menu--hidden"> <ul class="floating-menu_list"> <li class="floating-menu_item {!editLinkAvailable() && \'floating-menu_item--iconless\'}" onclick="{toggleEditLink.bind(this, true)}"> <svg if="{editLinkAvailable()}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">On</span> </li> <li class="floating-menu_item {editLinkAvailable() && \'floating-menu_item--iconless\'}" onclick="{toggleEditLink.bind(this, false)}"> <svg if="{!editLinkAvailable()}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Off</span> </li> </ul> </div> </div> </div> <div class="link-panel_url"> <input class="link-panel_input" type="text" riot-value="{editUrl()}" readonly disabled="{!editLinkAvailable()}" ondblclick="{selectAll}" onclick="{selectAll}"> <button class="Button Button--Small" onclick="{copyLink}">Copy</button> </div> </div>',
  '',
  'class="modal-share_panel" onclick="{dismissMenus}"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util.js');

var _opts = opts,
    canvas = _opts.canvas;
var access = canvas.access,
    people = canvas.people,
    config = canvas.config,
    operation = canvas.operation;

canvas.linkSharePanel = this;

this.canvas = canvas;
this.isViewMenuVisible = false;
this.isEditMenuVisible = false;

this.workspaceDisablesLinkSharing = function () {
  if (window.workspace) {
    if (!window.workspace.enablePublicLinkSharing) {
      return true;
    }
  }
};

this.canModify = function () {

  if (_this.workspaceDisablesLinkSharing()) {
    return false;
  }
  if (people) {
    var currentUser = people.currentUser;

    if (currentUser && currentUser.id === people.owner.id) {
      return true;
    }
    if (canvas.store.access.role === 'admin' || canvas.store.access.role === 'owner') {
      return true;
    }
  }
};

this.isInWorkspace = function () {
  if (window.workspace) return true;
};

this.editLinkAvailable = function () {
  return access.editKey && access.enablePublicEditLink;
};

this.viewLinkAvailable = function () {
  return access.enablePublicViewLink;
};

this.viewLinksCanComment = function () {
  return access.enableViewLinkCommenting;
};

this.editUrl = function () {
  if (access.permission !== 'edit') {
    return '';
  }

  return config.site_url + '/maps/' + access.publicIdentifier + '/edit/' + access.editKey;
};

this.viewUrl = function () {
  return config.site_url + '/maps/' + access.publicIdentifier;
};

this.selectAll = function (_ref) {
  var target = _ref.target;

  target.select();
};

this.copyLink = function (_ref2) {
  var target = _ref2.target;
  var textContent = target.textContent;

  target.textContent = 'Copied';
  setTimeout(function () {
    return target.textContent = textContent;
  }, 3000);

  (0, _util.copyToClipboard)({ text: target.previousElementSibling.value });
};

this.showViewMenu = function () {
  _this.isViewMenuVisible = true;
  _this.refs.viewMenu.classList.remove('floating-menu--hidden');
};

this.hideViewMenu = function () {
  _this.isViewMenuVisible = false;
  _this.refs.viewMenu.classList.add('floating-menu--hidden');
};

this.toggleViewMenu = function (event) {
  event.stopPropagation();

  if (_this.isViewMenuVisible) {
    _this.hideViewMenu();
  } else {
    _this.showViewMenu();
  }
};

this.showEditMenu = function () {
  var editMenu = _this.refs.editMenu;

  _this.isEditMenuVisible = true;
  editMenu && editMenu.classList.remove('floating-menu--hidden');
};

this.hideEditMenu = function () {
  var editMenu = _this.refs.editMenu;

  _this.isEditMenuVisible = false;
  editMenu && editMenu.classList.add('floating-menu--hidden');
};

this.toggleEditMenu = function (event) {
  event.stopPropagation();

  if (_this.isEditMenuVisible) {
    _this.hideEditMenu();
  } else {
    _this.showEditMenu();
  }
};

this.toggleViewLinkCommenting = function (e) {
  access.enableViewLinkCommenting = access.enableViewLinkCommenting ? false : true;
  _this.updateMapShareSettings({ field: 'enable_view_link_commenting', on: access.enableViewLinkCommenting });
};

this.toggleViewLink = function (on) {
  access.enablePublicViewLink = on;
  _this.updateMapShareSettings({ field: 'enable_public_view_link', on: on });
  _this.update();
};

this.toggleEditLink = function (on) {
  access.enablePublicEditLink = on;
  _this.updateMapShareSettings({ field: 'enable_public_edit_link', on: on });
  _this.update();

  if (!_this.editLinkAvailable()) {
    canvas.presentationSharePanel.presentationPermission = 'view';
  }
};

this.updateMapShareSettings = function (_ref3) {
  var field = _ref3.field,
      on = _ref3.on;

  operation.updateMapShareSettings({
    field: field,
    value: on ? 1 : 0,
    onFailure: function onFailure() {
      console.error('failed to update ' + field + ' link settings');
    }
  });
};

this.dismissMenus = function () {
  _this.hideViewMenu();
  _this.hideEditMenu();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('panel-link')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-share/panel-link.html
// module id = 771
// module chunks = 0